export default __webpack_public_path__ + "static/media/Armbands of Ferine Anger.f1b221e1.jpg";